// React
import React, { Component } from "react";

// Libraries
import Numeral from 'numeral';

// Panel
import { PanelHeading, PanelBody } from '../../Components';

// Stores
import { UserProfileStore, SampleDataStore, CurrencyStore } from '../../Stores';

import { ErrorHandler } from '../../Utils';

// Styles
import "./dashboard-flex.css";

class TradeHistory extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            trades : {},
            arrowClass : 'icon-arrow-up8 green-text',
            description : ["Your trades for the last day."],
            loading : true,
            message : null
        };

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Orders.componentDidMount()');

        // If user logged in, fetch the orders
        if(this.props.user !== null) {
            //this.getTrades(false);
            this.setState((prev, props) => {
                return {
                    loading : false,
                    message : {
                        title : 'Coming Soon',
                        details : "You'll be able to see trades in no time",
                        type : ''
                    }
                }
            });

        }
        else {
            this.getSampleTrades();
        }

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieves the orders from UserProfileStore
    getTrades(refresh) {
    
        UserProfileStore.getTrades(refresh)
            .then( (trades) => {

                var message = null;

                if(Object.keys(trades).length === 0) {
                    message = {
                        title : 'No Old Trades',
                        details : 'Looks like a nice day to do some trading..',
                        type : ''
                    }
                }

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        trades : trades,
                        message : message
                    }
                });

            }).catch( (error) => {

                var errorMessage = ErrorHandler.parseError('orders', error);

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        message : errorMessage
                    }
                });

            });

    }


    // Gets and displays the sample data orders
    getSampleTrades() {

        const trades = SampleDataStore.getTradeHistoryData();
        
        this.setState((prev, props) => {
            return {
                loading : false,
                trades : trades
            }
        });

    }


    // Retrieves the latest orders
    refreshTrades() {

        this.getTrades(true);

        this.setState((prev, props) => {
            return {
                loading : true
            }
        });

    }

    // Given any numbers of trades
    buildTrades(trades) {

        return (

            Object.entries(trades).map( ([timestamp, trade]) => {

                return (

                    <div className="flex-panel" key={timestamp}>

                        <div className="child-row">

                            <div className="row-box left">

                                <div>
                                    { trade.type } 
                                    <span className="label label-flat label-info left-pad">1:1</span>
                                </div>

                                <div className="lowlight"> 
                                    { trade.exchange} 
                                </div>

                            </div>

                            <div className="column-box left">

                                <div>
                                    <i className={ trade.type === "buy" ? 'icon-sort green-text right-pad' : 'icon-sort red-text right-pad'}></i>
                                </div>

                                <div className="row-box left">
                                    <div>{ trade.cryptoCurrency }</div>
                                    <div> { trade.tradeCurrency } </div>
                                </div>

                            </div>

                            <div className="row-box right">

                                <div>
                                    { 
                                        trade.volume > 1 ? 
                                        Numeral(trade.volume).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(trade.volume).format(CurrencyStore.getFormat(trade.cryptoCurrency)) 
                                    }
                                </div>

                                <div>
                                    <span className="right-pad">{ CurrencyStore.getCurrencySymbol(trade.tradeCurrency) }</span>
                                    { trade.price > 1 ? 
                                        Numeral(trade.price).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(trade.price).format(CurrencyStore.getFormat(trade.tradeCurrency)) 
                                    } 
                                </div>

                            </div>

                            <div className="row-box right">

                                <div>Total </div>

                                <div> 
                                    <span className="right-pad">{ CurrencyStore.getCurrencySymbol(trade.tradeCurrency) }</span>
                                    { 
                                        trade.total > 1 ? 
                                        Numeral(trade.total).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(trade.total).format(CurrencyStore.getFormat(trade.tradeCurrency)) 
                                    } 
                                </div>

                            </div>

                        </div>
                        
                    </div>

                )

            })
        )


    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    return (

        <div className="panel panel-flat bg-theme-700">

            <PanelHeading title={"Trade History"} description={this.state.description} 
                sample={this.props.user === null ? true : false}
                refresh={this.props.user === null ? null : this.refreshTrades} >
            </PanelHeading>

            <PanelBody loading={this.state.loading} message={this.state.message}>
                { this.buildTrades(this.state.trades) }
            </PanelBody>

        </div>

    );
  }
}

export default TradeHistory;



// WEBPACK FOOTER //
// ./src/Views/Dashboard/TradeHistory.js